export default __webpack_public_path__ + "static/media/extingaImg_2.1929d04e.png";